import processWalletTransactions from '/functions/process-wallet-transactions';
import request from '@wearetla/tla-essentials-tools/utilities/request';
import { createI18nInstance } from '/utilities/i18n';

const getT = () => createI18nInstance().t;


const bookingServices = {
	getData: () => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get('user/wallet', false, (payload, status, request) => {
				if (status === 200 && payload?.wallet) {
					resolve(payload.wallet);
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('Cüzdan bilgileri getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.')
					);
				}
			});
		});
	},
	getTransactions: () => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get('user/wallet/transactions', false, (payload, status, request) => {
				if (status === 200 && payload?.transactions) {
					resolve(
						processWalletTransactions(payload.transactions)
					);
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('İşlemler getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.')
					);
				}
			});
		});
	},
	preparePayment: (amount, ticketRedirect) => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.post(
				'order/prepare-wallet',
				{
					amount: amount,
					ticket_redirect: !!ticketRedirect,
				},
				(payload, status, request) => {
					if (status === 200 && payload?.order) {
						resolve({ ...payload.order, pay_saved_card: payload.pay_saved_card });
					} else {
						reject(
							request?.data?.meta?.messages ||
								t('Siparişiniz oluşturulurken bir hata ile karşılaşıldı, lütfen tekrar deneyin.')
						);
					}
				}
			);
		});
	},
	makePayment: (saleId, cardInfo, { openModal } = {}) => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.post(`order/payment/${saleId}`, cardInfo, (payload, status, request) => {
				if (status === 200 && payload) {
					if (payload.direct_payment === true) {
						resolve();
					} else if (payload?.payment?.gateway || payload?.form_data) {
						try {
							if (payload.form_data) {
								const decodedFormHtml = window.atob(payload.form_data);
								const parsed = new DOMParser().parseFromString(decodedFormHtml, 'text/html');
								const sourceForm = parsed.querySelector('form');
								if (!sourceForm) throw new TypeError('No form in form_data');

								openModal('bankRedirect', {
									method: sourceForm.method || 'POST',
									action: sourceForm.action,
									inputs: Object.fromEntries(
										[...sourceForm.querySelectorAll('input')].map((i) => [i.name, i.value])
									),
									onSuccess: resolve,
									onError: (errorMessage) => {
										reject(t('Ödeme alınamadı. Hata: "{{errorMessage}}"', { errorMessage }))
									},
									onClose: () => reject(),
								});
							} else {
								reject(t('Ödemeniz yapılırken bir hata ile karşılaşıldı, lütfen tekrar deneyin.'));
							}
						} catch (e) {
							if (payload?.payment?.gateway) {
								openModal('bankRedirect', {
									method: payload.payment.method ?? 'POST',
									action: payload.payment.gateway,
									inputs: payload.payment.inputs,
									onSuccess: resolve,
									onError: reject,
									onClose: () => reject(),
								});
							} else {
								reject(t('Ödemeniz yapılırken bir hata ile karşılaşıldı, lütfen tekrar deneyin.'));
							}
						}
					} else {
						reject(
							request?.data?.meta?.messages ||
								t('Ödemeniz yapılırken bir hata ile karşılaşıldı, lütfen tekrar deneyin.')
						);
					}
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('Ödemeniz yapılırken bir hata ile karşılaşıldı, lütfen tekrar deneyin.')
					);
				}
			});
		});
	},
	generateQr: () => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get(`user/wallet/qr`, false, (payload, status, request) => {
				if (status === 200 && payload?.wallet) {
					resolve(payload.wallet);
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('QR kodu getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.')
					);
				}
			});
		});
	},
	checkQrStatus: (qrCode) => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.post(
				`user/wallet/qr-check`,
				{
					qr_code: qrCode,
				},
				(payload, status, request) => {
					if (status === 200 && (payload?.wallet_order || payload?.wallet_order === null)) {
						resolve(payload?.wallet_order);
					} else {
						reject(
							request?.data?.meta?.messages ||
								t('QR kodu kontrol edilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.')
						);
					}
				}
			);
		});
	},
	getRefundAvailability: () => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get(`parameter/refund_available`, false, (payload, status, request) => {
				if (status === 200) {
					if(payload?.parameters[0]?.type) {
						resolve(parseInt(payload.parameters[0].value ?? '0'));
					}
					resolve ('0');
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('İade durumu getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.')
					);
				}
			});
		});
	},
	getRefundData: () => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get(`user/wallet/refund`, false, (payload, status, request) => {
				if (status === 200 && payload?.refund) {
					resolve({
						...payload,
						refund: {
							...payload.refund,
							total_refund:
								payload.refund.online_credit_card_refund + payload.refund.offline_refund,
						},
					});
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('İade verisi getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.')
					);
				}
			});
		});
	},
	makeRefund: (refundData) => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.post(`user/wallet/refund`, refundData, (payload, status, request) => {
				if (status === 200) {
					resolve(request?.data?.meta?.messages ?? { success: t('İadeniz gerçekleşti.') });
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('İadeniz gerçekleştirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.')
					);
				}
			});
		});
	},
};

export default bookingServices;
